import styled from "styled-components";
import { MessageContainer } from "styles/MessageContainer";

export const Container = styled(MessageContainer)`
  color: ${props => props.theme.colors.accent};
`;
